import { Component, Inject, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageType } from '@ogn-tracker/common/build/enum/message-type';
import { MessagesDTO, SendAllMessageDTO, SendGroupMessageDTO, SendSingleMessageDTO } from '@ogn-tracker/common/build/message';
import { SubSink } from 'subsink';
import { MessageQuery } from '../../../store/message/state/message.query';
import { MessageService } from '../../../store/message/state/message.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { GroupService } from '../../../store/group/state/group.service';
import { GroupQuery } from '../../../store/group/state/group.query';
import { GroupStore } from '../../../store/group/state/group.store';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-messages-popup',
  templateUrl: './messages-popup.component.html',
  styleUrls: ['./messages-popup.component.scss']
})
export class MessagesPopupComponent implements OnInit {
  messageTypes = Object.entries(MessageType);
  messageType = MessageType;
  messagesTypeString = {
    [MessageType.SINGLE]: 'Egyéni',
    [MessageType.GROUP]: 'Csoportos',
    [MessageType.ALL]: 'Területi'
  };
  newMessage = this.fb.group({
    messageType: [MessageType.SINGLE, Validators.required],
    message: ['', Validators.required],
    single: this.fb.group({
      id: [this.data?.deviceId ?? null, Validators.required]
    }),
    group: this.fb.group({
      groupName: ['', Validators.required],
      // ids: [null, Validators.required]
    }),
    all: this.fb.group({
      long: [null, Validators.required],
      lat: [null, Validators.required],
      radius: [null, Validators.required]
    })
  });
  dataSource = new MatTableDataSource<MessagesDTO>([]);
  columnsToDisplay = ['date', 'messageType', 'addressees', 'message'];
  subs = new SubSink();
  filteredOptions: Observable<string[]>;
  options = [];

  constructor(
    private fb: FormBuilder,
    private messagesQuery: MessageQuery,
    private messagesService: MessageService,
    private snackbar: MatSnackBar,
    private groupQuery: GroupQuery,
    private groupService: GroupService,
    private groupStore: GroupStore,
    @Inject(MAT_DIALOG_DATA) public data: {deviceId?: string}
  ) {
  }

  ngOnInit(): void {
    this.getMessages();
    this.groupQuery.select('groups').subscribe(v => this.options = v.map(group => group.name));
    this.subs.sink = this.groupService.getGroups().subscribe();
    this.filteredOptions = (this.newMessage.controls.group as FormGroup).controls.groupName.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );
  }

  send(): void {
    // this.dataSource.data = [...this.dataSource.data, message];
    if (this.newMessage.value.messageType === MessageType.ALL) {
      this.subs.sink = this.messagesService.postMessage({
        messageType: this.newMessage.value.messageType,
        message: this.newMessage.value.message,
        radius: this.newMessage.value.all.radius,
        position: {
          lat: this.newMessage.value.all.lat,
          lon: this.newMessage.value.all.long
        }
      } as SendAllMessageDTO).subscribe(
        _ => {
          this.snackbar.open('Elküldve!');
          this.getMessages();
        },
        _ => this.snackbar.open('Sikertelen küldés!')
      );
    } else if (this.newMessage.value.messageType === MessageType.SINGLE) {
      this.subs.sink = this.messagesService.postMessage({
        messageType: this.newMessage.value.messageType,
        message: this.newMessage.value.message,
        address: this.newMessage.value.single.id
      } as SendSingleMessageDTO).subscribe(
        _ => {
          this.snackbar.open('Elküldve!');
          this.getMessages();
        },
        _ => this.snackbar.open('Sikertelen küldés!')
      );
    } else if (this.newMessage.value.messageType === MessageType.GROUP) {
      this.subs.sink = this.messagesService.postMessage({
        messageType: this.newMessage.value.messageType,
        message: this.newMessage.value.message,
        groupId: this.getGroupId(this.newMessage.value.group.groupName)
      } as SendGroupMessageDTO).subscribe(
        _ => {
          this.snackbar.open('Elküldve!');
          this.getMessages();
        },
        _ => this.snackbar.open('Sikertelen küldés!')
      );
    }
  }

  getMessages(): void {
    this.subs.sink = this.messagesService.getMessages().subscribe(v => {
      this.dataSource.data = v.map((x: any) => {
        return {
          ...x,
          createdAt: new Date((x as any).createdAt),
          addresses: (x as any).deviceIds?.join(', ') ?? ''
        };
      });
    });
  }
  isSelectedMessageType(type: MessageType): boolean {
    return type === this.newMessage.controls.messageType.value;
  }

  getGroupId(name: string): number {
    return this.groupStore.getValue().groups.find(g => g.name === name).id;
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options
      .filter(group => group.toLowerCase().indexOf(filterValue) === 0);
  }
}
